"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyAdvertisingMachineList = emptyAdvertisingMachineList;
function emptyAdvertisingMachineList() {
    return {
        machines: [],
        summary: { costPerMachine: 0, enabledMachines: 0, estimatedCost: 0 },
    };
}
